(function(win, doc, undefined){
    if(!(doc.querySelector && doc.addEventListener)) return; // no js for IE8 and down
    'use strict';
    window.Reyez = {};
    (function _reyezFramework(ns){
        ns.loop = function _loop(items, func){
            var i = items.length;
            for(;i--;) func.apply(items, [items[i], i]);
        };
        ns.getScroll = function(){
            if(win.pageYOffset !== undefined) {
                return {'x': win.pageXOffset, 'y': win.pageYOffset};
            }
            else {
                var x, y, d = doc, r = d.documentElement, b = d.body;
                x = r.scrollLeft || b.scrollLeft || 0;
                y = r.scrollTop  || b.scrollTop  || 0;
                return {'x': x, 'y': y};
            }
        };
        ns.transitionEnd = (function _transitionEnd() {
            var el = doc.createElement('div');
            var transEndEventNames = {
                transition       : 'transitionend',
                MozTransition    : 'transitionend',
                WebkitTransition : 'webkitTransitionEnd',
                OTransition      : 'oTransitionEnd otransitionend'
            };
            for (var name in transEndEventNames) { if(el.style[name] !== undefined) return transEndEventNames[name]; }
            return false;
        })();
    })(Reyez);



    (function menu(clickerMenu) {
        if(!clickerMenu)return;
        var targetMenu = document.getElementById(clickerMenu.getAttribute('data-js-target'));

        targetMenu.addEventListener('click', onClick);
        clickerMenu.addEventListener('click', function() {
            onClick(clickerMenu)
        });

        function onClick(el) {
            if(!el)return;
            el.classList.toggle('is-active');
            targetMenu.classList.toggle('is-visible');
        }
    })(document.querySelector('.js-hamburger'));




    (function scrollTo(clickers) {
        clickers = Array.prototype.slice.call(clickers);
        clickers.forEach(init);

        function init(clicker, i){
            var id = clicker.getAttribute("href").substr(1);
            var el = document.getElementById(id);

            clicker.addEventListener('click', onClick);

            function onClick(e) {
                e && e.preventDefault();
                el.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
    })(document.querySelectorAll('.js-scroll-to'));


    (function _clickPassThrough(clickers){
        if(!clickers.length) return;
        Reyez.loop(clickers, init);
        function init(clicker){
            var target = clicker.querySelector(clicker.getAttribute('data-click-passthrough'));
            if(target) clicker.addEventListener('click', function(e){
                if(!e.isTrusted || e.target === target) return;
                target.click();
            })
        }
    })(doc.querySelectorAll('.js-click-passthrough'));



    (function flickityInit() {
        var elem = document.querySelectorAll('.js-flickity'), i;

        if(elem) {
            for (i = 0; i < elem.length; ++i) {
                var flkty = new Flickity(elem[i], {
                    // options
                    cellAlign: 'left',
                    // wrapAround: true,
                    draggable: false,
                    groupCells: true,
                    percentPosition: true,
                    prevNextButtons: false,
                    imagesLoaded: true,
                });
            }
        }

        var elem = document.querySelector('.js-faces');
        var items = document.querySelectorAll('.js-faces .gallery__item');

        if(elem && items.length > 4) {
            var flkty = new Flickity(elem, {
                // options
                cellAlign: 'left',
                wrapAround: true,
                draggable: true,
                percentPosition: true,
                prevNextButtons: false,
                pageDots: false,
                imagesLoaded: true,
            });
        }

        // Homepage
        var elem = document.querySelector('.js-flickity-home');
        var items = document.querySelectorAll('.js-flickity-home .gallery__item');

        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (viewportWidth < 768) {
            if(elem && items.length > 1) {
                var flkty = new Flickity(elem, {
                    // options
                    cellAlign: 'center',
                    groupCells: 1,
                    wrapAround: true,
                    draggable: true,
                    percentPosition: true,
                    prevNextButtons: true,
                    pageDots: true,
                    imagesLoaded: true,
                });
            }
        } 
    })();





})(window, document);
